export enum SpecialPermissions {
    BluewaterAdministration = 'LightSwitchApplication:BluewaterAdministration',
    StaffCanEdit = 'LightSwitchApplication:StaffCanEdit',
    StaffCanRead = 'LightSwitchApplication:StaffCanRead',
    SecurityAdministration = 'Microsoft.LightSwitch.Security:SecurityAdministration'
}
